import { Suspense } from "react";
import { Route, Routes, useNavigate } from "react-router";
import { useTypedParams } from "react-router-typesafe-routes";
import { PageLoading } from "~/components/loading";
import { v2Route } from "~/v2/routes";
import { RelationTypeDetail } from "./components/RelationTypeDetail";
import { RelationTypesContainer } from "./components/relationTypes.container";

function RelationTypeDetailRoute() {
  const { id = "" } = useTypedParams(v2Route.admin.relationTypes.detail);
  const navigate = useNavigate();
  return <RelationTypeDetail key={id} relationTypeId={id} onBack={() => navigate("..")} />;
}

export function RelationTypesRoutes() {
  return (
    <Suspense fallback={<PageLoading />}>
      <Routes>
        <Route index element={<RelationTypesContainer />} />
        <Route path=":id" element={<RelationTypeDetailRoute />} />
      </Routes>
    </Suspense>
  );
}
